// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#login {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 30px;
}

#login-form, #login-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: max(50%, 350px);
}

img {
  width: 18rem;
}

#login-with {
  padding-top: 28px;
  position: relative;
  display: inline-block;
  width: 100%;
  text-align: center;
}
#login-with h1 {
  font-size: 1rem;
  position: relative;
  display: inline-block;
}
#login-with h1:before,
#login-with h1:after {
  content: "";
  position: absolute;
  top: 65%;
  border-bottom: 1px solid grey;
  width: 20vw;
  margin: 0 14px;
}
#login-with h1:before {
  right: 100%;
}
#login-with h1:after {
  left: 100%;
}

#login-type-holder {
  color: var(--color-primary);
  margin-top: 20px;
  border-bottom: 2px solid var(--color-primary);
  width: 100%;
  text-align: center;
  font-size: 1.4rem;
}

#login-inputs {
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.login-input {
  height: 40px;
  font-size: 1.2rem;
}

#remember-password {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#remember-password-check {
  height: 18px;
  width: 18px;
}

#login-btn, #sign-up-btn {
  width: max(300px, 80%);
  border-radius: 5px;
  font-size: 1.5rem;
  margin: 10px 0;
  font-weight: 100;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

#login-btn {
  color: white;
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}

#sign-up-btn {
  color: var(--color-primary);
  background-color: white;
  border-color: white;
}

#sign-up {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  width: max(50%, 380px);
  height: 100%;
  padding-top: 50px;
  row-gap: 10px;
}
#sign-up div {
  text-align: center;
}

@media only screen and (max-width: 380px) {
  #login {
    padding: 30px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/login/login.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;AACJ;AAAI;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;AAEN;AAAI;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,6BAAA;EACA,WAAA;EACA,cAAA;AAEN;AAAI;EACE,WAAA;AAEN;AAAI;EACE,UAAA;AAEN;;AAEE;EACE,2BAAA;EACA,gBAAA;EACA,6CAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AACJ;;AAEE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AACJ;;AAEE;EACE,YAAA;EACA,iBAAA;AACJ;;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;;AAEE;EACE,YAAA;EACA,WAAA;AACJ;;AAEE;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,+GAAA;AACJ;;AAEE;EACE,YAAA;EACA,sCAAA;EACA,kCAAA;AACJ;;AAEE;EACE,2BAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEE;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;AACJ;AAAI;EACI,kBAAA;AAER;;AAEA;EAEE;IACE,eAAA;EAAF;AACF","sourcesContent":["#login {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    padding: 30px;\r\n}\r\n\r\n#login-form, #login-header  {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: max(50%, 350px);\r\n}\r\n\r\nimg {\r\n    width: 18rem;\r\n}\r\n\r\n#login-with {\r\n    padding-top: 28px;\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 100%;\r\n    text-align: center;\r\n    h1 {\r\n      font-size: 1rem;\r\n      position: relative;\r\n      display: inline-block;\r\n    }\r\n    h1:before,\r\n    h1:after {\r\n      content: \"\";\r\n      position: absolute;\r\n      top: 65%;\r\n      border-bottom: 1px solid grey;\r\n      width: 20vw;\r\n      margin: 0 14px;\r\n    }\r\n    h1:before {\r\n      right: 100%;\r\n    }\r\n    h1:after {\r\n      left: 100%;\r\n    }\r\n  }\r\n\r\n  #login-type-holder {\r\n    color: var(--color-primary);\r\n    margin-top: 20px;\r\n    border-bottom: 2px solid var(--color-primary);\r\n    width: 100%;\r\n    text-align: center;\r\n    font-size: 1.4rem;\r\n  }\r\n\r\n  #login-inputs {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 10px;\r\n  }\r\n\r\n  .login-input {\r\n    height: 40px;\r\n    font-size: 1.2rem;\r\n  }\r\n\r\n  #remember-password {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n  }\r\n\r\n  #remember-password-check {\r\n    height: 18px;\r\n    width: 18px;\r\n  }\r\n\r\n  #login-btn, #sign-up-btn {\r\n    width: max(300px, 80%);\r\n    border-radius: 5px;\r\n    font-size: 1.5rem;\r\n    margin: 10px 0;\r\n    font-weight: 100;\r\n    box-shadow: 0 3px 1px -2px rgba(0,0,0,0.2),0 2px 2px 0 rgba(0,0,0,0.14),0 1px 5px 0 rgba(0,0,0,0.12);;\r\n  }\r\n\r\n  #login-btn {\r\n    color: white;\r\n    background-color: var(--color-primary);\r\n    border-color: var(--color-primary);\r\n  }\r\n\r\n  #sign-up-btn {\r\n    color: var(--color-primary);\r\n    background-color: white;\r\n    border-color: white;\r\n  }\r\n\r\n  #sign-up {\r\n    display: flex;\r\n    box-sizing: border-box;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    width: max(50%, 380px);\r\n    height: 100%;\r\n    padding-top: 50px;\r\n    row-gap: 10px;\r\n    div {\r\n        text-align: center;\r\n    }\r\n  }\r\n\r\n@media only screen and (max-width: 380px)\r\n{\r\n  #login {\r\n    padding: 30px 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
